import { downgradeComponent } from "@angular/upgrade/static";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { HelpNavigationModule } from "./help.navigation";
import { ContactPageComponent } from "./_routes/contact-page/contact-page.component";


export class Config {

    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        $stateProvider.state(HelpNavigationModule.ParentRoot, {
            url: "/help",
            views: { "content@app": { component: "contactPage" } },
            data: { translation: 'Common.Support' }
        });
    }
}

angular
    .module("app.help", ["app.directives"])
    .config(Config)

    .directive("contactPage", downgradeComponent({ component: ContactPageComponent }))
    ;
